<p-button
    class="btn-primary"
    [variant]="!isPrimaryBtn ? 'outlined' : undefined"
    [icon]="isPrimaryBtn ? 'far fa-paper-plane' : undefined"
    (onClick)="onClick()"
    [pTooltip]="tooltip"
    [label]="label"
    tooltipPosition="bottom">
</p-button>
